import TagManager from 'react-gtm-module'
import environment from '_environments'

/**
 * Google Tag Manager setup for the legacy entry. The new shell leaves GTM out
 * (product decision, 2026-10-05: no third-party tag container on an origin
 * holding the session). PostHog and Sentry start from their own modules
 * (`posthog.ts`, `sentry.ts`). LogRocket and Microsoft Clarity were removed
 * (product decision, 2026-10-06, MAM-1072).
 *
 * Kept out of the `@/services` barrel for the same reason as `posthog.ts`: the
 * barrel also builds the legacy Cognito/Amplify setup and, through
 * `user.service`, the legacy Redux store. The barrel re-exports this function,
 * so the legacy entry keeps importing it from `./services` (MAM-1015).
 */
let attempted = false

/** Starts GTM at most once per page load, outside local and dev builds. */
export const configureAnalytics = () => {
  if (environment.isLocal || environment.isDev) {
    console.info('Analytics not initialized in development')
    return
  }
  const gtmId = environment.keys.gtm
  if (attempted || !gtmId) return
  attempted = true
  try {
    TagManager.initialize({ gtmId })
  } catch (error) {
    console.error('Failed to initialize GTM:', error)
  }
}
